document.addEventListener('DOMContentLoaded',()=>{
  const t=document.querySelector('.mobile-toggle'),m=document.querySelector('.mobile-menu');
  if(t&&m)t.addEventListener('click',()=>m.classList.toggle('is-open'));
  document.querySelectorAll('[data-add-to-cart]').forEach(b=>b.addEventListener('click',async e=>{
    e.preventDefault();
    const f=e.currentTarget.closest('form');
    if(!f)return;
    const variant=Number(f.dataset.variant||f.querySelector('[name="id"]')?.value);
    const quantity=Number(f.querySelector('[name="quantity"]')?.value||1);
    if(!variant){f.submit();return;}
    e.currentTarget.disabled=true;
    try{
      const r=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:variant,quantity:quantity}]})});
      if(r.ok){
        const cart=await fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(x=>x.json());
        document.querySelectorAll('.cart-count').forEach(el=>el.textContent=cart.item_count);
        location.href='/cart';
      }else{f.submit();}
    }catch(err){f.submit();}
    finally{e.currentTarget.disabled=false;}
  }));
});
